module.exports = __webpack_public_path__ + "img/good4.314f6ee1.png";